import axios from "axios";
import { isEmpty, omit, omitBy, isNil, map } from "lodash";
import useSession from "Hooks/session.hook";
import errorHandler from "Utils/error-handler";
import { getAccessToken } from "Helpers/session";
import normalize from "Utils/normalizer";
import { DefaultFilter, Pagination, Sorting } from "Types/common.types";

const url = `${process.env.API_URL}/${process.env.API_VER}/report/incident`;

interface IncidentReportFilters extends DefaultFilter {
  type?: string;
  category?: string;
  orFields?: string;
}

export const fetchIncidentReport = async (incidentID: string) => {
  const accessToken = getAccessToken();

  try {
    const response = await axios({
      method: "POST",
      url: `${url}/fetch`,
      data: { incidentReportID: incidentID },
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return response.data.incidentReport;
  } catch (err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await fetchIncidentReport(incidentID);
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};

export const listIncidentReports = async (
  filters?: IncidentReportFilters,
  pagination?: Pagination | null,
  sorting?: Sorting,
) => {
  const accessToken = getAccessToken();

  try {
    const response = await axios({
      method: "POST",
      url: `${url}/list`,
      data: omitBy(
        {
          filters: omitBy(filters, (value) => isNil(value) || value === ""),
          pagination,
          sorting,
        },
        isNil,
      ),
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return response.data.incidentReports;
  } catch (err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await listIncidentReports(filters, pagination, sorting);
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};

export const updateIncidentReportStatus = async (incidentReportID: string, newStatus: string) => {
  const accessToken = getAccessToken();

  try {
    const response = await axios({
      method: "POST",
      url: `${url}/update`,
      data: { incidentReportID, newStatus },
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return response.data;
  } catch (err: any) {
    const { error } = err.response?.data || {};
    console.log(err.response);

    if (!isEmpty(error)) {
      const callback = async () => await updateIncidentReportStatus(incidentReportID, newStatus);
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};

export const fetchReportStatisticsCount = async (companyOrgID: string) => {
  const accessToken = getAccessToken();

  try {
    const response = await axios({
      method: "POST",
      url: `${url}/statistics/fetch`,
      data: { companyOrgID: companyOrgID },
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return response.data;
  } catch (err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await fetchReportStatisticsCount(companyOrgID);
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};
